export default __webpack_public_path__ + "static/media/loading-2.5ad60076.png";